// extracted by mini-css-extract-plugin
module.exports = {"link":"Link-module__link___2wji8","active":"Link-module__active___1CPuI Link-module__link___2wji8"};